export const PaymentSystems = {
    default: {
        icon: '/_core/assets/themes/transcription/assets/img/transcription/credit-card.svg',
        title: 'Credit Card',
    },
    paypal: {
        icon: '/_core/assets/themes/transcription/assets/img/transcription/paypal.svg',
        title: 'PayPal',
    }
};